import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Field } from 'formik'

export const Header = styled.h2`
  color: #002855;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
  font-family: ${themeGet('textFontFamily')};

  ${themeGet('breakpoints.tablet')} {
    margin-bottom: 0;
    text-align: center;
  }
`

export const EmailInputWrapper = styled.div`
  margin-bottom: 1.3125rem;
`

export const InputLabelContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.8125rem;
  color: ${themeGet('colors.darkGray')};
`

export const InputLabel = styled.label`
  font-family: ${themeGet('textFontFamily')};
  color: #25282a;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
`

export const BulkUsersInfoDiv = styled.div`
  font-family: ${themeGet('fontFamily')};
`

export const EmailInputField = styled(Field)`
  height: 2.6875rem;
  width: 100%;
  border: 0.0938rem solid;
  border-color: ${props =>
    themeGet(props.displayerror === 'true' ? 'colors.error' : 'colors.blue')};
  border-radius: 0.3125rem;
  box-sizing: border-box;
  padding: 1rem 4rem 0.875rem 0.9375rem;
  font-family: ${themeGet('fontFamily')};

  &::placeholder {
    font-size: 1rem;
    color: ${themeGet('colors.mediumGray')};
    text-align: left;
    letter-spacing: 0;
    line-height: 1.25rem;
    font-style: normal;
  }

  &:focus-visible {
    outline: none;
    border: 0.0938rem solid;
    border-color: ${props =>
      themeGet(
        props.displayerror === 'true'
          ? 'colors.error'
          : 'colors.secondStepBlue',
      )};
  }

  @media (max-height: 790px) {
    height: 4rem;
  }
`
export const EmailTextAreaField = styled(EmailInputField)`
  height: 16.0625rem;
  resize: none;
  padding-right: 1rem;
`

export const InputModeToggle = styled.button`
  border: none;
  background: none;
  width: fit-content;
  padding: 0;
  cursor: pointer;
  color: ${themeGet('colors.blue')};
  font-family: ${themeGet('fontFamilySemibold')};
  text-align: left;
  margin-top: 1.1875rem;
  &:hover {
    outline: none;
    color: ${themeGet('colors.secondStepBlue')};
  }
`

export const TextInputContainer = styled.div`
  position: relative;
`

export const Error = styled.div`
  margin-top: 0.25rem;
  font-family: ${themeGet('fontFamily')};
  color: ${themeGet('colors.error')};
`



// WEBPACK FOOTER //
// ./src/components/AddUserModalInputText/component.styles.js